export default "__VITE_PUBLIC_ASSET__076303fe__"